let attempts = 0;
const interval = setInterval(() => {
  const subtitle = document.querySelector('.kaching-bundles__subscriptions__subtitle');
  const message = document.querySelector('#subscription-message');

  if (subtitle && message) {
    subtitle.insertAdjacentElement('afterend', message);
    clearInterval(interval);
  }

  if (++attempts > 20) clearInterval(interval);
}, 300);



document.addEventListener("DOMContentLoaded", function () {
  const bundleContainer = document.querySelector(".kaching-bundles__subscriptions");
const subtitles = document.querySelectorAll(".kaching-bundles__bar-subtitle");
const bundleBarss = document.querySelectorAll(".kaching-bundles__bar");

function updateSubtitlesVisibility() {
  const selectedBars = bundleContainer.querySelectorAll(
    ".kaching-bundles__bar.kaching-bundles__bar--selected"
  );

  selectedBars.forEach(bar => {
    const siblingBars = Array.from(
      bar.parentElement.querySelectorAll(".kaching-bundles__bar")
    );
    const selectedIndex = siblingBars.indexOf(bar);

    console.log("selectedIndex", selectedIndex);

    if (selectedIndex === 1) {
      // add class to ALL bars
      bundleBarss.forEach(el => el.classList.add("onetime-selected"));
    } else {
      // remove from ALL bars
      bundleBarss.forEach(el => el.classList.remove("onetime-selected"));
    }
  });
}

  // Initialize on page load
  updateSubtitlesVisibility();

  bundleContainer.addEventListener("click", function (e) {
    const bar = e.target.closest(".kaching-bundles__bar");
    if (!bar) return;

    // Only remove --selected from sibling bars in the same parent
    const siblingBars = Array.from(bar.parentElement.querySelectorAll(".kaching-bundles__bar"));
    siblingBars.forEach(b => b.classList.remove("kaching-bundles__bar--selected"));

    // Add --selected to clicked bar
    bar.classList.add("kaching-bundles__bar--selected");

    // console.log("Bar clicked, index:", siblingBars.indexOf(bar));

    // Update subtitles based on clicked bar
    updateSubtitlesVisibility();
  });
});
